import { css } from '@emotion/css'
import { spacing, breakpoint, mediaQueryHelper, shorthandHelper } from '@offerzen/pinata-shame'

import { mobileToolbarHeight } from '../Toolbar'

const styles = {
  wrapper: css({
    display: 'flex',
    marginTop: mobileToolbarHeight,

    [mediaQueryHelper(breakpoint.tablet)]: {
      marginTop: 0,
      padding: shorthandHelper([spacing.medium, 0]),
    },
  }),

  container: css({
    padding: 0,
    marginTop: spacing.small,
    marginBottom: spacing.medium,
    display: 'flex',
  }),
}

export default styles

export const containerDirection = direction => {
  switch (direction) {
    case 'horizontal':
      return css({
        flexDirection: 'row',
        alignItems: 'flex-start',
      })

    default:
      return css({
        flexDirection: 'column',
      })
  }
}

export const containerWrap = wrap => {
  switch (wrap) {
    case 'wrap':
      return css({
        flexWrap: 'wrap',
        justifyContent: 'space-between',
      })

    default:
      return css({
        flexWrap: 'initial',
      })
  }
}
